import { render } from "./OfferListingPageShimmer.vue?vue&type=template&id=dec3e530"
import script from "./OfferListingPageShimmer.vue?vue&type=script&lang=js"
export * from "./OfferListingPageShimmer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__